import { useEffect, useState } from 'react';
import { FiImage, FiPackage } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import type { ProductImage } from '../../../../types';
import * as s from './ProductImageThumbnail.styles';

interface ProductImageThumbnailProps {
  image?: ProductImage | null;
  alt: string;
  size?: 'table' | 'preview';
  imageCount?: number;
  onClick?: () => void;
}

const ProductImageThumbnail = ({
  image,
  alt,
  size = 'table',
  imageCount = 1,
  onClick,
}: ProductImageThumbnailProps) => {
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [image?.image_url]);

  const isPreview = size === 'preview';
  const iconSize = isPreview ? 42 : 26;
  const title = !image?.image_url || hasError ? t('noProductImage') : alt;
  const content = (
    <>
      {image?.image_url && !hasError ? (
        <s.ThumbnailImage
          src={image.image_url}
          alt={alt}
          onError={() => setHasError(true)}
        />
      ) : (
        <s.ThumbnailFallback aria-label={t('noProductImage')}>
          {hasError ? <FiImage size={iconSize} aria-hidden="true" /> : <FiPackage size={iconSize} aria-hidden="true" />}
        </s.ThumbnailFallback>
      )}
      {imageCount > 1 && <s.ImageCount>{imageCount}</s.ImageCount>}
    </>
  );

  return onClick ? (
    <s.ThumbnailButton
      type="button"
      $preview={isPreview}
      title={title}
      aria-label={t('viewProductImages')}
      onClick={onClick}
    >
      <s.ThumbnailBox $preview={isPreview}>{content}</s.ThumbnailBox>
    </s.ThumbnailButton>
  ) : (
    <s.ThumbnailBox $preview={isPreview} title={title}>{content}</s.ThumbnailBox>
  );
};

export default ProductImageThumbnail;
